import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ClerkProvider, useClerk } from '@clerk/clerk-react';
import { Toaster } from 'sonner';
import { ConfettiProvider } from './contexts/ConfettiContext';
import { TrashProvider } from './contexts/TrashContext';

const HomePage = lazy(() => import('./pages/HomePage.jsx'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage.jsx'));
const TermsPage = lazy(() => import('./pages/TermsPage.jsx'));
const ShopsPage = lazy(() => import('./pages/ShopsPage.jsx'));
const HelpCenterPage = lazy(() => import('./pages/HelpCenterPage.jsx'));
const AppPage = lazy(() => import('./app/App'));

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

function AppContent() {
  const { signOut } = useClerk()

  // Ctrl+Shift+L to force logout from anywhere
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'L') {
        e.preventDefault()
        signOut()
        localStorage.clear()
        window.location.href = '/'
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [signOut])

  return (
    <ConfettiProvider>
      <TrashProvider>
        <Suspense fallback={<div className="min-h-screen bg-[#f2f2f2]" />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/shops" element={<ShopsPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
            <Route path="/app/*" element={<AppPage />} />
          </Routes>
        </Suspense>
        <Toaster position="bottom-center" />
      </TrashProvider>
    </ConfettiProvider>
  );
}

function App() {
  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      appearance={{
        cssLayerName: 'clerk',
        variables: {
          colorPrimary: '#7C4BFF',
        },
        elements: {
          formButtonPrimary: 'bg-[#7C4BFF] hover:bg-[#6B3EE8] text-white',
        },
      }}
    >
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ClerkProvider>
  );
}

export default App;
